<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>待审核订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="search-box">
      <div class="item">
        商户ID：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.Id"
        ></el-input>
      </div>
      <div class="item">
        收款账号：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.BeneficiaryAccountNumber"
        >
        </el-input>
      </div>
      <div class="item">
        收款姓名：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.BeneficiaryAccountName"
        >
        </el-input>
      </div>
      <div class="item">
        角色名：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.PlayerRoleName"
        ></el-input>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="tips">
      商户账户余额<font color="#ff0000">{{ view.merchantBalance }}</font
      >元, 待处理笔数<font color="#ff0000"> {{ view.waitToProcessCount }}</font
      >笔, 待出款金额<font color="#ff0000">{{ view.waitToPay }}</font
      >元
    </div>
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column property="id" label="商户ID" align="center">
      </el-table-column>
      <el-table-column property="partitionName" label="分区名称" align="center">
      </el-table-column>
      <el-table-column
        property="playerRoleName"
        label="角色名称"
        align="center"
      >
      </el-table-column>
      <el-table-column property="applyAmount" label="申请金额" align="center">
      </el-table-column>
      <el-table-column property="realAmount" label="出款金额" align="center">
      </el-table-column>
      <el-table-column property="auditReason" label="待审核原因" align="center">
      </el-table-column>
      <el-table-column
        property="beneficiaryAccountNumber"
        label="收款账号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="beneficiaryAccountName"
        label="收款姓名"
        align="center"
      >
      </el-table-column>
      <el-table-column property="contact" label="联系方式" align="center">
      </el-table-column>
      <el-table-column property="createTime" label="申请时间" align="center">
      </el-table-column>
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <!-- 自由账户配置 -->
    <el-dialog title="自由账户配置" :visible.sync="dialogConfig">
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改前" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改后" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改时间" align="center">
        </el-table-column>
        <el-table-column property="name" label="操作人" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      dialogConfig: false,
      tableData: [],
      view: {},
      form: {
        Id: '',
        ApplicationUserId: '',
        BeneficiaryAccountNumber: '',
        BeneficiaryAccountName: '',
        PlayerRoleName: '',
        PageNumber: 1,
        PageSize: 12,
        total: 0
      }
    };
  },
  created() {
    this.getLists();
    this.getView();
  },
  methods: {
    async getLists() {
      let header = await mgr();
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      api
        .get('/api/Paid/WaitToAudiOrderList', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async getView() {
      let header = await mgr();
      api
        .get('/api/Paid/GetWaitAuditOrderOverview', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.view = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    search() {
      this.tableData = [];
      this.form.PageNumber = 1;
      this.getLists();
    },
    changePage(page) {
      console.log(page);
      this.form.PageNumber = page;
      this.getLists();
    },
    reset() {
      this.tableData = [];
      this.form = {
        Id: '',
        ApplicationUserId: '',
        BeneficiaryAccountNumber: '',
        BeneficiaryAccountName: '',
        PlayerRoleName: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      };
      this.getLists();
    }
  }
};
</script>
<style></style>
<style scoped>
.gs_container {
  background-color: #fff;
}
</style>
